import { ZirroMark } from "@zirro/editor";

/** Mark plus "Zirro" wordmark and an optional product label. */
export function ZirroLogo({ product }: { product?: string }) {
  return (
    <span className="zirro-logo">
      <ZirroMark className="zirro-logo__mark" />
      <span className="zirro-logo__word">Zirro</span>
      {product ? <span className="zirro-logo__product">{product}</span> : null}
    </span>
  );
}
